// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {clsx} from 'clsx';
import React, {type ReactNode} from 'react';

import {InlineComboboxInput} from './InlineComboboxInput';

const LABEL_CLASSES = clsx(
  'block leading-6 font-semibold mb-8 grow-0 shrink-0'
);

const CONTAINER_CLASSES = clsx(
  'flex flex-row grow-0 shrink-0 items-center gap-8  mb-8'
);

const ICON_CLASSES = clsx('block m-0');

type InlineComboboxSearchProps = {
  afterInput?: ReactNode;
  label: string;
  labelProps: any;
  inputProps: any;
};

export function InlineComboboxSearch({
  afterInput,
  label,
  labelProps,
  inputProps,
}: InlineComboboxSearchProps) {
  const icon = <Icon name="search" className={ICON_CLASSES} color="#79808A" />;

  return (
    <>
      <label className={LABEL_CLASSES} {...labelProps}>
        {label}
      </label>
      <div className={CONTAINER_CLASSES}>
        <InlineComboboxInput {...inputProps} beforeInput={icon} />
        {afterInput}
      </div>
    </>
  );
}
